import { BaseDto } from "@/shared/dtos/base-dto";

export class config_gaugesDto extends BaseDto {
  public limit_min!: number;
  public limit_max!: number;
  public color!: string;
  public id_dashboard!: number;
}
